import PropTypes from 'prop-types';
import React, { createContext, useContext, useEffect, useState } from 'react';

import loadScriptByUrl from '@/common/helpers/loadScriptByUrl';

const showGRecaptchaBadgeClassName = 'show-grecaptcha-badge';
const RecaptchaContext = createContext(null);

export const useRecaptcha = () => useContext(RecaptchaContext);

const getRecaptchaElement = () => {
  const list = document.getElementsByClassName('grecaptcha-badge');
  return list && list[0];
};

const RecaptchaContextProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.body.classList.add(showGRecaptchaBadgeClassName);

    loadScriptByUrl(
      'recaptcha-key',
      `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`,
      () => {
        const recaptchaElement = getRecaptchaElement();
        if (recaptchaElement) {
          recaptchaElement.style.display = 'block';
          setIsLoading(false);
        }
      },
      [],
    );

    return () => {
      const recaptchaElement = getRecaptchaElement();
      if (recaptchaElement) {
        recaptchaElement.style.display = 'none';
      }
    };
  });

  return (
    <RecaptchaContext.Provider value={{ isLoading }}>
      {children}
    </RecaptchaContext.Provider>
  );
};

RecaptchaContextProvider.defaultProps = {};

RecaptchaContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default RecaptchaContextProvider;
